import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const RichTextEditor = ({ value, onChange, label, helperText, minHeight = 300, defaultSourceMode = false, showSourceToggle = true }) => {
  const [sourceMode, setSourceMode] = useState(defaultSourceMode);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline"],
      ["link"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"],
    ],
  };

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
        {label && (
          <Typography sx={{ fontSize: 13, color: "rgba(42, 51, 78, 0.8)" }}>
            {label}
          </Typography>
        )}
        {showSourceToggle && (
          <Button
            size="small"
            disableRipple
            onClick={() => setSourceMode((prev) => !prev)}
            sx={{
              textTransform: "none",
              fontSize: 11,
              minWidth: "auto",
              px: 1,
              py: 0.25,
              borderRadius: "4px",
              color: sourceMode ? "#fff" : "rgba(42, 51, 78, 0.6)",
              backgroundColor: sourceMode ? "rgba(42, 51, 78, 0.8)" : "transparent",
              "&:hover": { backgroundColor: sourceMode ? "rgba(42, 51, 78, 0.9)" : "rgba(42, 51, 78, 0.05)" },
            }}
          >
            {"</>"}
          </Button>
        )}
      </Box>

      {sourceMode ? (
        <Box
          component="textarea"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          sx={{
            width: "100%",
            minHeight: `${minHeight + 42}px`,
            borderRadius: "10px",
            backgroundColor: "#F9FAFF",
            border: "1px solid rgba(42, 51, 78, 0.12)",
            p: 1.5,
            fontSize: 13,
            fontFamily: "monospace",
            color: "#2A334E",
            resize: "vertical",
            outline: "none",
            boxSizing: "border-box",
            "&:focus": { borderColor: "rgba(42, 51, 78, 0.4)" },
          }}
        />
      ) : (
        <Box
          sx={{
            "& .quill": {
              borderRadius: "10px",
              backgroundColor: "#F9FAFF",
              border: "1px solid rgba(42, 51, 78, 0.12)",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: "#fff",
                borderColor: "rgba(42, 51, 78, 0.25)",
              },
            },
            "& .ql-container": {
              borderRadius: "0 0 10px 10px",
              minHeight: `${minHeight}px`,
              fontSize: 13,
              fontFamily: "inherit",
            },
            "& .ql-toolbar": {
              borderRadius: "10px 10px 0 0",
              backgroundColor: "#fff",
              borderBottom: "1px solid rgba(42, 51, 78, 0.12)",
            },
            "& .ql-editor": {
              minHeight: `${minHeight}px`,
              color: "#2A334E",
              "& p:last-child": {
                marginBottom: 0,
              },
              "& p": {
                margin: "0",
                padding: "0",
              },
            },
            "& .ql-editor.ql-blank::before": {
              color: "rgba(42, 51, 78, 0.5)",
              fontStyle: "normal",
            },
          }}
        >
          <ReactQuill value={value} onChange={onChange} modules={modules} theme="snow" />
        </Box>
      )}

      {helperText && (
        <Typography variant="caption" sx={{ color: "rgba(42, 51, 78, 0.6)", mt: 0.5, display: "block" }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default RichTextEditor;
